import { render, staticRenderFns } from "./ConfigViewerEthBridge.vue?vue&type=template&id=72d8ff8e"
import script from "./ConfigViewerEthBridge.vue?vue&type=script&lang=js"
export * from "./ConfigViewerEthBridge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports